import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { BookingDto } from '../bookings/models';

@Injectable({
  providedIn: 'root',
})
export class GoogleCalendaryService {
  apiName = 'Default';
  

  createOrUpdateBookingEventByBookingAndGoogleEventIdAndTitleAndDescriptionAndStartAndEndAndLocation = (booking: BookingDto, googleEventId: string, title: string, description: string, start: string, end: string, location?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: `/api/app/google-calendary/or-update-booking-event/${googleEventId}`,
      params: { title, description, start, end, location },
      body: booking,
    },
    { apiName: this.apiName,...config });
  

  createOrUpdatePreetiBhojEventByBookingAndTitleAndDescriptionAndStartAndEnd = (booking: BookingDto, title: string, description: string, start: string, end: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: '/api/app/google-calendary/or-update-preeti-bhoj-event',
      params: { title, description, start, end },
      body: booking,
    },
    { apiName: this.apiName,...config });
  

  deleteBookingEventByGoogleEventId = (googleEventId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/google-calendary/booking-event/${googleEventId}`,
    },
    { apiName: this.apiName,...config });
  

  getEvents = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'GET',
      url: '/api/app/google-calendary/events',
    },
    { apiName: this.apiName,...config });
  

  syncPoojaBookingCalendar = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/google-calendary/sync-pooja-booking-calendar',
    },
    { apiName: this.apiName,...config });
  

  syncPoojaBookingCalendarEndpoint = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/google-calendary/sync-pooja-booking-calendar-endpoint',
    },
    { apiName: this.apiName,...config });
  

  syncPoojaBookings = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/google-calendary/sync-pooja-bookings',
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
